import { getRoute } from "@utils/route";

export const CONTACT_US_PAGE_URL = '/contact-us';

export const routeContactUsPage = () => getRoute(CONTACT_US_PAGE_URL);
